export default "__VITE_ASSET__47f78a12__"